// extracted by mini-css-extract-plugin
export default {"shop-card":"no2U8jJU","shopCard":"no2U8jJU","circle":"eYGuZE86","initials":"WzPtk62x","data":"ZchZNWjz","selected":"bTAhBWXm","header":"yp8l1pI6"};